import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { CustomerProduct } from '../types/customerProduct';
import { DataFetchError } from '../../utils/ErrorClass';

interface UseOrderlistResult {
  products: CustomerProduct[];
  error: string | null;
}

const useOrderlist = (customer_id: number): UseOrderlistResult => {
  const [products, setProducts] = useState<CustomerProduct[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      const { data, error } = await supabase
      .rpc('get_customer_products_with_order_count', {
        p_customer_id: customer_id,
        month_interval: 3 // 何カ月で集計するか
      });

      if (error) {
        throw new DataFetchError(error.message);
      }

      setProducts(data as CustomerProduct[]);
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    }
  }, [customer_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { products, error };
};

export default useOrderlist;
